'use client'

import Link from 'next/link'

import { trackEvent, type UmamiEventData } from '@/lib/umami'

type TrackedLinkProps = React.ComponentProps<typeof Link> & {
  event: string
  eventData?: UmamiEventData
}

export function TrackedLink({
  event,
  eventData,
  onClick,
  ...props
}: TrackedLinkProps) {
  return (
    <Link
      {...props}
      onClick={(e) => {
        trackEvent(event, eventData)
        onClick?.(e)
      }}
    />
  )
}
